export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-sewerage-api.tracwater.online', // Develop Server
  portalId: '686770bb2b2267e9ec5120ce',
  portalTypeId: '689596ee18f8a8985a2aebc5',
};
